"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_uniq_1 = __importDefault(require("lodash.uniq"));
const uuid_1 = require("uuid");
const common_1 = require("@affinidi/common");
const SdkError_1 = __importDefault(require("../shared/SdkError"));
const common_2 = require("@affinidi/common");
const _helpers_1 = require("../_helpers");
let HolderService = class HolderService {
    constructor(options, component) {
        this._didMap = {};
        const { registryUrl, metricsUrl } = options;
        this._accessApiKey = options.accessApiKey;
        const isApiKeyAValidUuid = options.apiKey && uuid_1.validate(options.apiKey);
        if (isApiKeyAValidUuid) {
            const apiKeyBuffer = common_1.KeysService.sha256(Buffer.from(options.apiKey));
            this._accessApiKey = apiKeyBuffer.toString('hex');
        }
        this._affinityService = new common_1.Affinity({
            apiKey: this._accessApiKey,
            registryUrl: registryUrl,
            metricsUrl: metricsUrl,
            component: component,
        });
        this._digestService = new common_1.DigestService();
    }
    buildCredentialOfferResponse(credentialOfferToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const credentialOffer = common_1.JwtService.fromJWT(credentialOfferToken);
            const { interactionToken: offerRequestInteractionToken } = credentialOffer.payload;
            const { callbackURL, offeredCredentials } = offerRequestInteractionToken;
            const selectedCredentials = offeredCredentials;
            const interactionToken = {
                callbackURL,
                selectedCredentials,
            };
            const offerResponse = yield common_1.JwtService.buildJWTInteractionToken(interactionToken, 'credentialOfferResponse', credentialOffer);
            return offerResponse;
        });
    }
    buildCredentialResponse(credentialRequestToken, suppliedCredentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const credentialRequest = common_1.JwtService.fromJWT(credentialRequestToken);
            const { callbackURL } = credentialRequest.payload.interactionToken;
            const interactionToken = {
                callbackURL,
                suppliedCredentials,
            };
            const credentialResponse = yield common_1.JwtService.buildJWTInteractionToken(interactionToken, 'credentialResponse', credentialRequest);
            return credentialResponse;
        });
    }
    /* istanbul ignore next: private method */
    _keyIdToDid(keyId) {
        return common_1.DidDocumentService.keyIdToDid(keyId);
    }
    /* istanbul ignore next: private method */
    _resolveUniqDIDs(dids) {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [];
            const uniqDIDs = lodash_uniq_1.default(dids);
            for (const did of uniqDIDs) {
                promises.push(this._resolveDid(did));
            }
            yield Promise.all(promises);
        });
    }
    /* istanbul ignore next: private method */
    _resolveDid(did) {
        return __awaiter(this, void 0, void 0, function* () {
            const didDocument = yield this._affinityService.resolveDid(did);
            this._didMap[did] = didDocument;
            return didDocument;
        });
    }
    /* istanbul ignore next: private method */
    _validateCredentials(credentials, holderKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const signatureValidationResults = [];
            for (const credential of credentials) {
                const didDocument = this._didMap[this._keyIdToDid(credential.issuer)];
                const { result, error } = yield this._affinityService.validateCredential(credential, holderKey, didDocument);
                signatureValidationResults.push({ result, error });
            }
            return signatureValidationResults;
        });
    }
    verifyCredentialShareResponse(credentialShareResponseToken, credentialShareRequestToken, 
    /* istanbul ignore next: shouldOwn = true is covered ! */
    shouldOwn = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let isValid = true;
            const errors = [];
            const credentialShareResponse = common_1.JwtService.fromJWT(credentialShareResponseToken);
            const { iss: issuer, jti } = credentialShareResponse.payload;
            const { suppliedCredentials } = credentialShareResponse.payload.interactionToken;
            const didArray = [];
            const holderDid = this._keyIdToDid(issuer);
            didArray.push(holderDid);
            for (const credential of suppliedCredentials) {
                const issuerDid = this._keyIdToDid(credential.issuer);
                didArray.push(issuerDid);
            }
            yield this._resolveUniqDIDs(didArray);
            const didDocument = this._didMap[holderDid];
            try {
                yield this._affinityService.validateJWT(credentialShareResponseToken, credentialShareRequestToken, didDocument);
            }
            catch (error) {
                if (error.message === 'Token expired') {
                    throw new SdkError_1.default('COR-19');
                }
                throw error;
            }
            let results;
            if (shouldOwn) {
                results = yield this._validateCredentials(suppliedCredentials, issuer);
            }
            else {
                results = yield this._validateCredentials(suppliedCredentials);
            }
            for (const result of results) {
                if (result.result === false) {
                    isValid = false;
                    errors.push(result.error);
                }
            }
            return { isValid, did: holderDid, jti, suppliedCredentials, errors };
        });
    }
    /**
     * @description Slightly modified version of Affinity.validateJWT,
     * this validates that the given challenge was signed by the expected
     * issuer and that it isn't exipred.
     * @param vp - the presentation to be validated
     * when needed to verify if holder is a subject of VC
     * @returns { isValid, did, challenge, suppliedPresentations, errors }
     *
     * isValid - boolean, result of the verification
     *
     * did - DID of the VP issuer (holder of the shared VCs)
     *
     * challenge - unique identifier for the presentation.
     * You are responsible for checking this to protect against replay attacks
     *
     * suppliedPresentations - the validated presentation
     *
     * errors - array of validation errors
     */
    verifyPresentationChallenge(challenge, expectedIssuer) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = common_1.Affinity.fromJwt(challenge);
            const { payload } = token;
            const strippedExpectedIssuer = _helpers_1.stripParamsFromDidUrl(expectedIssuer);
            const strippedPayloadIssuer = _helpers_1.stripParamsFromDidUrl(payload.iss);
            if (strippedExpectedIssuer !== strippedPayloadIssuer) {
                throw new Error('Token not issued by expected issuer.');
            }
            const did = common_1.DidDocumentService.keyIdToDid(expectedIssuer);
            const didDocument = yield this._affinityService.resolveDid(did);
            const publicKey = common_1.DidDocumentService.getPublicKey(strippedExpectedIssuer, didDocument, payload.kid);
            const { digest: tokenDigest, signature } = this._digestService.getTokenDigest(token);
            const isSignatureVerified = common_1.KeysService.verify(tokenDigest, publicKey, signature);
            if (!isSignatureVerified) {
                throw new Error('Signature on token is invalid');
            }
            if (payload.exp < Date.now()) {
                throw new Error('Token expired');
            }
        });
    }
};
HolderService = __decorate([
    common_2.profile()
], HolderService);
exports.default = HolderService;
//# sourceMappingURL=HolderService.js.map